import { PaymentElement } from "@stripe/react-stripe-js";
import { useEffect, useState } from "react";
import { useStripe, useElements } from "@stripe/react-stripe-js";
import Loader from "../../views/admin/Common/Loader";
import { useSnackbar } from "notistack";
import { useNavigate } from "react-router-dom";
import {
  GenrateMatch,
  updateSport,
  CurrentTournament,
  RemoveWaitlist,
  withdrawalSlotsAPI,
  holdSlotAPI,
  RemoveAllPlayerWaitlist,
  cancelPaymentAPI,
} from "../../API/player";
import { UpdateProfile } from "../../API/auth";
import Swal from "sweetalert2";

export default function CheckoutForm({
  sports,
  waitList,
  waitListPlayer,
  slotID,
  tokenValue,
  countdown,
  TeamChange,
  SelectedTeam,
}) {
  console.log("slotID checkout", slotID);
  console.log("update team checkout", TeamChange);
  console.log("update waitListPlayer checkout", waitListPlayer);
  console.log("update waitList checkout", waitList);

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  let navigate = useNavigate();
  const stripe = useStripe();
  const elements = useElements();
  const [message, setMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [loaderStatus, setloaderStatus] = useState(false);

  var participantId = "";
  var tournamentId = "";
  // useEffect(()=>{
  //   let callAPI = async () => {
  //     if (slotID != null || slotID != undefined) {

  //       let formData = {
  //         "document_id": slotID,
  //         "email_check": true,
  //         "slot_token":tokenValue
  //       }
  //       let slotres = await withdrawalSlotsAPI(formData);
  //       const holdTime = new Date(slotres.data.data.hold_time);
  //       const currentTime = new Date();
  //       if ( holdTime < currentTime) {
  //         Swal.fire({
  //           title: "Time is expired ",
  //           text: "Your 10 minutes payment window is expired , you can not make payment now..",
  //           icon: "error",
  //           confirmButtonColor: "#3085d6",
  //           confirmButtonText: "OK",
  //           allowOutsideClick: false,
  //           allowEscapeKey: false

  //         }).then((result) => {
  //           if (result.isConfirmed) {
  //               // window.location.href('/logout')
  //               navigate('/dashboard')
  //           }
  //       });
  //       }
  //     }

  // }
  // if (countdown == null) {
  //   Swal.fire({
  //     title: "Time UP",
  //     text: "Your time to book the slot is over.",
  //     icon: "error",
  //     confirmButtonColor: "#3085d6",
  //     confirmButtonText: "OK",
  //     allowOutsideClick: false,
  //     allowEscapeKey: false

  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //         // window.location.href('/logout')
  //         navigate('/dashboard')
  //     }
  // });
  // }
  //   callAPI();
  // },[])
  useEffect(() => {
    if (countdown == null) {
      Swal.fire({
        title: "Payment Session Expired",
        text: "Your payment session has timed out. Please start the checkout process again to complete your payment.",
        icon: "error",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "OK",
        allowOutsideClick: false,
        allowEscapeKey: false,
        showCancelButton: true,
        cancelButtonText: "close",
      }).then((result) => {
        console.log("5");
        navigate("/select-sport");
      });
    }
  }, [countdown]);

  const cancelPayment = () => {
    Swal.fire({
      title: "Are you sure you want to cancel payment?",
      text: "You will no longer be able to book the slot.",
      // icon: "warning",
      confirmButtonColor: "#3085d6",
      confirmButtonText: "YES",
      showCancelButton: true,
      cancelButtonText: "No",
      cancelButtonColor: "black",
      cancelButtonText: "Close",
    }).then(async (result) => {
      if (result.isConfirmed) {
        // window.location.href('/logout')
        if (waitListPlayer == false && slotID == null) {
          // normal payment cancel
          let formData = {
            regularPayment: true,
          };
          setloaderStatus(true);

          let res = await cancelPaymentAPI(formData);
          console.log(res);
          if (res.status) {
            setloaderStatus(false);
          } else {
            setloaderStatus(false);
            Swal.fire({
              title: "unable to cancel payment.",
              text: "Something went wrong while canceling your payment request.",
              icon: "error",
              confirmButtonColor: "#3085d6",
              confirmButtonText: "ok",
            }).then(() => {
              navigate("/dashboard");
            });
          }
        } else if (waitListPlayer && slotID != null) {
          // waiting payment cancel
          let formData = {
            regularPayment: false,
            slotID: slotID,
          };
          if (TeamChange) {
            formData.teamchange = TeamChange;
            formData.team = SelectedTeam;
          }
          setloaderStatus(true);

          let res = await cancelPaymentAPI(formData);
          console.log(res);
          if (res.status) {
            setloaderStatus(false);
          } else {
            setloaderStatus(false);
            Swal.fire({
              title: "unable to cancel payment.",
              text: "Something went wrong while canceling your payment request.",
              icon: "error",
              confirmButtonColor: "#3085d6",
              confirmButtonText: "ok",
            }).then(() => {
              navigate("/dashboard");
            });
          }
        }
        navigate("/dashboard");
      }
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!stripe || !elements) {
      console.log("Herere");
      setMessage("Please fill all the details");
      return;
    } else {
      async function makePayment() {
        console.log("in make payment");
        try {
          console.log("start payment");

          setloaderStatus(true);
          const { error, paymentIntent } = await stripe.confirmPayment({
            elements,
            confirmParams: {
              return_url: "https://google.com",
            },
            redirect: "if_required",
          });

          if (error) {
            setloaderStatus(false);
            enqueueSnackbar(error, {
              variant: "error",
              action: (key) => (
                <button
                  className="toast_close_btn"
                  onClick={() => {
                    // Close the Snackbar
                    closeSnackbar(key);
                  }}
                >
                  X
                </button>
              ),
            });
          } else if (paymentIntent && paymentIntent.status === "succeeded") {
            if (sports.length > 0) {
              let res = await CurrentTournament();
              if (res.status) {
                let formData = {
                  document_id: slotID,
                  status: "false",
                };
                if (TeamChange) {
                  formData.TeamChange = true;
                }
                if (slotID != undefined || slotID != null) {
                  let releaseSlot = await holdSlotAPI(formData);
                  if (releaseSlot.data.status) {
                  } else {
                    enqueueSnackbar("Unable to enroll", {
                      variant: "error",
                      action: (key) => (
                        <button
                          className="toast_close_btn"
                          onClick={() => {
                            // Close the Snackbar
                            closeSnackbar(key);
                          }}
                        >
                          X
                        </button>
                      ),
                    });
                  }
                }
                tournamentId = res.data.data.id;
                let resSport = await updateSport({
                  tournament_id: res.data.data.id,
                  sports: sports,
                  status: waitList ? "waiting" : "approved",
                  payment_intent: paymentIntent,
                });
                if (resSport.data) {
                  console.log("genrating matcjh");
                  participantId = resSport.data.data.player_id;
                  let formData = {
                    tournament_id: tournamentId,
                    participant_id: participantId,
                    badminton: sports.includes("badminton") ? true : false,
                    table_tenis: sports.includes("tennis") ? true : false,
                    bowling: sports.includes("bowling") ? true : false,
                    twokrun: sports.includes("twok_run") ? true : false,
                    waitlist: waitListPlayer ? true : false,
                    // 'twokrun': sports.includes('2k_run') ? true : false,
                  };
                  console.log("update team payment successfull", TeamChange);
                  if (TeamChange) {
                    let formTeamData = {
                      id: participantId,
                      corporate_email: SelectedTeam,
                    };
                    let res = await UpdateProfile(formTeamData);
                    if (res.data.status) {
                      // delete all the entry in waiting list for this player
                      let EmptyData = {
                        data: null,
                      };
                      let deleteAllWaitlist = await RemoveAllPlayerWaitlist(
                        EmptyData
                      );
                      enqueueSnackbar("Team changed successfully", {
                        variant: "success",
                        action: (key) => (
                          <button
                            className="toast_close_btn"
                            onClick={() => {
                              // Close the Snackbar
                              closeSnackbar(key);
                            }}
                          >
                            X
                          </button>
                        ),
                      });
                    } else {
                      enqueueSnackbar(res.data.message, {
                        variant: "error",
                        action: (key) => (
                          <button
                            className="toast_close_btn"
                            onClick={() => {
                              // Close the Snackbar
                              closeSnackbar(key);
                            }}
                          >
                            X
                          </button>
                        ),
                      });
                    }
                  }
                  console.log("hitting Match aPI");
                  let resMatch = await GenrateMatch(formData);
                  if (resMatch.status) {
                    console.log("hitting Match sucess");

                    let formDataWait = {
                      tournament_id: tournamentId,
                      participant_id: participantId,
                      game_type: sports.includes("badminton")
                        ? "badminton"
                        : sports.includes("tennis")
                        ? "table_tenis"
                        : sports.includes("bowling")
                        ? "bowling"
                        : sports.includes("twok_run")
                        ? "2k_run"
                        : null,
                    };
                    if (waitListPlayer && TeamChange == false) {
                      console.log("Calling removing API");
                      let res = await RemoveWaitlist(formDataWait);
                      console.log(res);
                      if (res.data.status || res.status) {
                        console.log("user remobed in true");

                        setloaderStatus(false);
                        enqueueSnackbar("Welcome to UPG", {
                          variant: "success",
                          action: (key) => (
                            <button
                              className="toast_close_btn"
                              onClick={() => {
                                // Close the Snackbar
                                closeSnackbar(key);
                              }}
                            >
                              X
                            </button>
                          ),
                        });
                        navigate("/dashboard");
                      } else {
                        setloaderStatus(false);
                        enqueueSnackbar("Something went wrong", {
                          variant: "error",
                          action: (key) => (
                            <button
                              className="toast_close_btn"
                              onClick={() => {
                                // Close the Snackbar
                                closeSnackbar(key);
                              }}
                            >
                              X
                            </button>
                          ),
                        });
                        navigate("/logout");
                      }
                    } else {
                      console.log("not removing API");
                      console.log("user remobed in false");

                      setloaderStatus(false);
                      enqueueSnackbar("Welcome to UPG", {
                        variant: "success",
                        action: (key) => (
                          <button
                            className="toast_close_btn"
                            onClick={() => {
                              // Close the Snackbar
                              closeSnackbar(key);
                            }}
                          >
                            X
                          </button>
                        ),
                      });
                      navigate("/dashboard");
                    }
                  } else {
                    console.log("hitting Match aPI error");

                    setloaderStatus(false);
                    enqueueSnackbar("unable to genrate match", {
                      variant: "error",
                      action: (key) => (
                        <button
                          className="toast_close_btn"
                          onClick={() => {
                            // Close the Snackbar
                            closeSnackbar(key);
                          }}
                        >
                          X
                        </button>
                      ),
                    });
                    navigate("/logout");
                  }
                } else {
                  console.log("here in elsedI");
                  setloaderStatus(false);
                  enqueueSnackbar("Unable to participate in sports", {
                    variant: "error",
                    action: (key) => (
                      <button
                        className="toast_close_btn"
                        onClick={() => {
                          // Close the Snackbar
                          closeSnackbar(key);
                        }}
                      >
                        X
                      </button>
                    ),
                  });
                }

                // const promises = sports.map(async(sport) => {
                // });
                // const results = await Promise.all(promises);
                // console.log(participantId);
              } else {
                setloaderStatus(false);

                enqueueSnackbar("No Tournament is live", {
                  variant: "error",
                  action: (key) => (
                    <button
                      className="toast_close_btn"
                      onClick={() => {
                        // Close the Snackbar
                        closeSnackbar(key);
                      }}
                    >
                      X
                    </button>
                  ),
                });
              }
            }
          } else {
            setloaderStatus(false);

            enqueueSnackbar("Payment failed", {
              variant: "error",
              action: (key) => (
                <button
                  className="toast_close_btn"
                  onClick={() => {
                    // Close the Snackbar
                    closeSnackbar(key);
                  }}
                >
                  X
                </button>
              ),
            });
          }
        } catch (error) {
          console.error(error);
        }
        setIsLoading(false);
      }
      if (slotID != null || slotID != undefined) {
        let formData = {
          document_id: slotID,
          email_check: true,
          slot_token: tokenValue,
        };
        let slotres = await withdrawalSlotsAPI(formData);
        console.log("Slot APi res checkout");
        console.log(slotres);
        // check with timw also
        if (slotres.data.status) {
          console.log("cheking time");
          const holdTime = new Date(slotres.data.data.hold_time);
          const currentTime = new Date();

          if (
            slotres.data.data.slot_available === "true" &&
            holdTime > currentTime &&
            slotres.data.data.token_expiry == tokenValue
          ) {
            console.log(currentTime - holdTime);

            makePayment();
          }
          //  else if (TeamChange) {

          //   makePayment()
          //   //  allow team change person to make payment
          // }
          else {
            Swal.fire({
              title: "Payment Session Expired",
              text: "Your payment session has timed out. Please start the checkout process again to complete your payment.",
              icon: "error",
              confirmButtonColor: "#3085d6",
              confirmButtonText: "OK",
              allowOutsideClick: false,
              allowEscapeKey: false,
              showCancelButton: true,
              cancelButtonText: "close",
            }).then((result) => {
              console.log("6");
              navigate("/select-sport");
            });
          }
        } else {
          console.log("here in else");
        }
      } else {
        makePayment();
      }
    }
  };

  return (
    <>
      {loaderStatus ? <Loader /> : null}
      <form id="payment-form" onSubmit={handleSubmit}>
        <PaymentElement id="payment-element" />
        <button
          className="mt-3 float-end btn btn-light submit-button text-white fs-6 pay_submit_btn"
          disabled={isLoading || !stripe || !elements || countdown == null}
          id="submit"
        >
          <span id="button-text ">
            {isLoading ? (
              <div className="spinner" id="spinner"></div>
            ) : countdown == null ? (
              "Time Up"
            ) : (
              "Pay now"
            )}
          </span>
        </button>

        <button
          className="mt-3 float-end btn btn-light submit-button text-white fs-6"
          onClick={(e) => cancelPayment(e)}
          disabled={isLoading || !stripe || !elements}
          id="cancel"
          type="button"
        >
          <span id="button-text ">
            {isLoading ? (
              <div className="spinner" id="spinner"></div>
            ) : (
              "Cancel"
            )}
          </span>
        </button>
        {/* Show any error or success messages */}
        {message && <div id="payment-message">{message}</div>}
      </form>
    </>
  );
}
